module.exports = __webpack_public_path__ + "img/reject.445e11fd.svg";